export type Notifications =
	'MISSING_WORKING_DAYS' |
	'ON_CALL' |
	'WORKING_TIME' |
	'APPROVED_DAYS_OFF' |
	'UNAPPROVED_DAYS_OFF' |
	'EMPLOYEE_UNSUBMITTED_TIMECARD_NOTIFICATION';

export const Notifications: any = {
	EMPLOYEE_UNSUBMITTED_TIMECARD_NOTIFICATION: <Notifications> 'EMPLOYEE_UNSUBMITTED_TIMECARD_NOTIFICATION',
	MISSING_WORKING_DAYS: <Notifications> 'MISSING_WORKING_DAYS',
	ON_CALL: <Notifications> 'ON_CALL',
	APPROVED_DAYS_OFF: <Notifications> 'APPROVED_DAYS_OFF',
	WORKING_TIME: <Notifications> 'WORKING_TIME',
	UNAPPROVED_DAYS_OFF: <Notifications> 'UNAPPROVED_DAYS_OFF',
};



// WEBPACK FOOTER //
// ./src/app/my-time/notifications/notifications.enum.ts